import MainLayout from './main-layout';
import LegacyMainLayout from './main-layout.legacy';

export { MainLayout, LegacyMainLayout };
